import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Link,
    Paper,
    Divider,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { Navigate } from 'react-router-dom';
import { ciamAuth } from '../configs/oktaConfigs';
import { useOktaAuth } from '@okta/okta-react';

const features = [
    "Invite your patients to participate in clinical research",
    "View clinical research data from your patients",
    "View patients currently enrolled in clinical research",
    "View metrics and analytics of your clinical research",
    "Design new clinical research studies",
];

export default function ECPLogin() {

    const [login, setLogin] = useState(false);
    const [loginInfo, setLoginInfo] = useState({});
    const { oktaAuth, authState } = useOktaAuth();

    // Show loading while authState is being determined
    if (!authState) return <div>Loading...</div>;
    if (authState?.isAuthenticated) return <Navigate to="/" />;

    const handleLogin = async () => {
        const authInstance = ciamAuth;
        await authInstance.signInWithRedirect();
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f9fbfd",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Container
                maxWidth="lg"
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "calc(100vh - 70px)",
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        borderRadius: 3,
                        width: "100%",
                        maxWidth: 1200,
                        mx: "auto",
                        py: { xs: 3, md: 0 },
                        px: { xs: 0, md: 0 },
                        display: "flex",
                        minHeight: { md: 600, xs: "auto" },
                        overflow: "hidden",
                    }}
                >
                    <Grid container>
                        {/* Left side */}
                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                bgcolor: "#fff",
                                px: { xs: 4, md: 7 },
                                pt: { xs: 4, md: 7 },
                                pb: { xs: 2, md: 3 },
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                minHeight: 600,
                            }}
                        >
                            <Typography
                                variant="h3"
                                component="h1"
                                sx={{
                                    color: "#003595",
                                    fontWeight: 400,
                                    mb: 2,
                                    fontSize: { xs: "2rem", md: "2.5rem" },
                                }}
                            >
                                Marlo Labs
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    color: "#444",
                                    fontWeight: 400,
                                    fontSize: "1.15rem",
                                }}
                            >
                                A digital clinical research tool for ECPs:
                            </Typography>
                            <List sx={{ mb: 4 }}>
                                {features.map((feature) => (
                                    <ListItem key={feature} disableGutters sx={{ alignItems: "flex-start" }}>
                                        <ListItemIcon sx={{ minWidth: 36, mt: 0.2 }}>
                                            <CheckCircleOutlineIcon sx={{ color: "#003595" }} fontSize="medium" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={feature}
                                            primaryTypographyProps={{
                                                variant: "body1",
                                                sx: { color: "#444", fontSize: "1.08rem", mb: 0 },
                                            }}
                                            sx={{ mt: 0, mb: 0 }}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                            <Box
                                sx={{
                                    width: "100%",
                                    borderRadius: 4,
                                    overflow: "hidden",
                                    mt: "auto",
                                    mb: 2,
                                    boxShadow: 2,
                                    background: "#e5eaf2",
                                }}
                            >
                                <Box
                                    component="img"
                                    src="/images/marlo.png"
                                    alt="Clinical research illustration"
                                    sx={{
                                        width: "100%",
                                        objectFit: "cover",
                                        aspectRatio: "2/1",
                                        display: "block",
                                    }}
                                />
                            </Box>
                        </Grid>

                        {/* Right side */}
                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                bgcolor: "#f4f7fa",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: 600,
                                py: 5,
                            }}
                        >
                            <Box
                                sx={{
                                    width: "80%",
                                    maxWidth: 410,
                                    mx: "auto",
                                    textAlign: "center",
                                }}
                            >
                                <Typography
                                    variant="h4"
                                    component="h2"
                                    sx={{
                                        color: "#003595",
                                        mb: 5,
                                        fontWeight: 400,
                                        fontSize: { xs: "1.6rem", md: "2rem" },
                                    }}
                                >
                                    Optometrist Log in:
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{
                                        backgroundColor: "#003595",
                                        "&:hover": {
                                            backgroundColor: "#002566",
                                        },
                                        borderRadius: 6,
                                        px: 0,
                                        py: 2,
                                        fontWeight: 700,
                                        fontSize: "1.18rem",
                                        letterSpacing: 1,
                                        mb: 2,
                                        boxShadow: "none",
                                        textTransform: "uppercase",
                                    }}
                                    onClick={() => handleLogin()}
                                >
                                    LOG IN
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </Box>
    );
}